import { AppViewerOverrides } from '../types';
import { EventsApp as app } from './app';
import { EventListItem } from './EventListItem';

export const EventsAppUI: AppViewerOverrides = {
  documentType: app.documentType,
  Item: EventListItem,
};
